import { SaveOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Input, InputNumber, List, Radio, RadioChangeEvent, Row, Tag, Typography } from "antd";
import { observer } from "mobx-react";
import { TaskStatus } from "../../models/student";
import Subjects from "../../models/subjects";
import StudentTaskStore from "../../stores/students/student-task-item";

const StudentTaskItem: React.FC<{ task: StudentTaskStore, indx: number, subject: Subjects }> = ({ task, indx, subject }) => {

    const { Text } = Typography;

    const handleChangeAnswer = (event: React.ChangeEvent<HTMLInputElement>) => {
        task.changeStudentAnswer(event.target.value);
    }

    const handleChangePoints = (value: number | null) => {
        task.changeStudentPoint(value);
    }

    const handleSaveResult = () => {
        task.saveResult();
    }

    const handleRadioChange = (event: RadioChangeEvent) => {
        task.changeTaskState(event.target.value);
    }

    return (
        <List.Item key={task.data.id}>
            <List.Item.Meta title={
                <Flex justify="flex-start" gap="middle">
                    <Text strong>{indx + 1}.</Text>
                    <Tag color="purple">{`Задача ${task.data.taskId}`}</Tag>
                    <Tag color="cyan">{`Номер в КИМ ${task.data.numberInKim}`}</Tag>
                    {task.isSaved !== undefined && <Tag color={task.isSaved ? "lime" : "magenta"}>{task.isSaved ? "Сохранено" : "Не сохранено"}</Tag>}
                    {task.data.status !== TaskStatus.NOT_DONE && <Tag color={task.data.status === TaskStatus.SUCCESS ? "green" : "red"}>
                        {task.data.status === TaskStatus.SUCCESS ? "Правильно" : "Ошибка"}</Tag>}
                </Flex>
            } />
            <Row gutter={8} >
                <Col span={6}>
                    <Radio.Group
                        value={task.data.status}
                        defaultValue={TaskStatus.NOT_DONE}
                        onChange={handleRadioChange}
                        options={[
                            { value: TaskStatus.NOT_DONE, label: 'Не выполнено' },
                            { value: TaskStatus.SUCCESS, label: 'Правильно' },
                            { value: TaskStatus.ERROR, label: 'Ошибка' }
                        ]}
                    />
                </Col>
                <Col span={4}>
                    <Input disabled={task.data.taskPoints > 1} placeholder={`Ответ ${task.data.taskAnswer || ""}`} value={task.data.studentAnswer} onChange={handleChangeAnswer} />
                </Col>
                <Col span={2}>
                    <InputNumber
                        disabled={task.data.taskPoints === 1 && !!task.data.taskAnswer}
                        value={task.data.studentPoints}
                        onChange={handleChangePoints}
                        title="Баллы"
                        min={0}
                        max={task.data.taskPoints}
                    />
                </Col>
                <Col span={2}>
                    <Button icon={<SaveOutlined />} onClick={handleSaveResult} />
                </Col>
            </Row>
        </List.Item>
    );
}

export default observer(StudentTaskItem);